<template>
  <form>
    <PageHeader title="タスク依頼セットマスタ" class="list">
      <template #title-header-content>
        <div class="ml-auto">
          <PrimaryButton text="新規" size="normal hover:bg-pink-400" class="new" @click="edit({})"/>
        </div>
      </template>
    </PageHeader>
    <main class="absolute top-20 w-screen bottom-4 -mt-2 leading-8 list">
      <div class="mx-auto px-2 sm:px-4 lg:px-8 h-full">
        <div class="bg-white rounded-md border border-gray-200 overflow-auto h-full">
          <table class="table">
            <thead class="th sticky top-0">
              <tr class="column">
                <th class="text-green-700 text-left p-2">カテゴリ</th>
                <th class="text-left p-2">名前</th>
                <th class="text-left p-2 text-blue-700">内容</th>
                <th class=""></th>
                <th class=""></th>
              </tr>
            </thead>
            <tbody v-for="(row, index) in list" :key="index">
              <tr :class="setColor(index)" class="hover-color text-sm">
                <!-- カテゴリー -->
                <td class="min-w-130 p-2 text-green-700 text-xs whitespace-pre-line">{{ row.category?row.category.join('\r\n'):'' }}</td>
                <!-- セット名 -->
                <td class="p-2 font-bold">{{ row.name }}</td>
                <!-- 内容 -->
                <td class="p-2 text-blue-600 whitespace-pre-line">{{getDetails(row)}}</td>
                <td class="p-1 text-right"><PrimaryButton text="編集" @click="edit(row)" /></td>
                <td class="p-1 text-right"><PrimaryButton text="削除" @click="deleteData(row)" size="normal bg-indigo-200 text-indigo-700 hover:bg-indigo-300"/></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </main>
    <!-- 編集・新規登録モーダル -->
    <SubTaskSetMasterEditModal 
      v-model="modalShow"
      :target="editData"
      :subList="list"
      :open="modalShow"
      @modalClose="modalClose"
    />
  </form>
</template>
<script>

import PageHeader from '@components/PageHeader.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import SubTaskSetMasterEditModal from '../components/SubTaskSetMasterEditModal.vue'
import * as taskRequestManager from '@managers/taskRequestManager'
import * as dialogs from '@libs/dialogs'
import * as logManager from '@managers/logManager'
import PageModel from '../../main/pages/PageModel.vue'

export default {
  extends: PageModel,
  components: {
    PrimaryButton,
    PageHeader,
    SubTaskSetMasterEditModal
  },

  data() {
    return {
      // サブタスク依頼セット
      list: [],
      // モーダル表示
      modalShow: false,
      // 編集する内容
      editData: {},
    }
  },

  async created() {
    await this.getData()
  },

  computed: {
    /**
     * 内容の表示
     */
    getDetails() {
      return (row) => {
        if (row.group && row.group.length) {
          const res = row.group.map((d) => {
            return d.task
          })
          return res.join('\r\n')
        }
        return null
      }
    }
  },

  methods: {
    /**
     * データ取得
     */
    async getData() {
      this.list = []
      let res = await taskRequestManager.getTaskSetMst(this)
      if (res && res.length > 0) {
        this.list = res
      } else if (res.error) {
        alert(res.msg)
      }
    },

    /**
     * 編集イベント
     * @param data 編集内容
     */
    edit(data) {
      this.modalShow = true
      this.editData = data
    },

    /**
     * 背景色設定
     */
    setColor(i) {
      if (i % 2 != 0) {
        return 'bg-blue'
      }
    },

    /**
     * モーダルを閉じる
     */
    async modalClose() {
      this.modalShow = false
      await this.getData()
    },

    /**
     * 削除イベント
     * @param row 削除するデータ
     */
    async deleteData(row) {
      const dialogResult = await dialogs.showWarningConfirmDialog('削除', '削除してよろしいですか？')
      if (dialogResult === 'YES') {
        let registApp = await this.$pigeon.deleteTask(row._id)
        if (!registApp) {
          await dialogs.showErrorDialog('エラー', '削除できませんでした。')
          return
        }
        logManager.recording(this, logManager.Loglevel.INFO, 'タスク依頼セットマスタ', '削除', 'タスク依頼セット（' + row.task + '）を削除しました。')
        await this.getData()
      }
    }
  }
}
</script>

<style scoped>
.list {
  min-width: 1400px !important;
}

.table {
  width: 100%;
}

.column th {
  background: #edecf7;
}

.bg-blue {
  background: rgb(243 247 249);
}

.new {
  width: 200px;
  background: #eb94c8;
}

.hover-color:hover {
  background-color: rgba(198, 233, 239, 0.853);
}
</style>